import { useState, useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from '@/components/ui/Dialog.jsx';
import { Button } from '@/components/ui/Button.jsx';
import { RefreshCw, FileDown } from 'lucide-react';
import { api } from '@/lib/api.js';

export default function PayslipPreviewDialog({ item, onClose }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const prevUrl = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.blob(`/payslips/item/${item.id}/preview`).then((url) => {
      if (!cancelled) { setBlobUrl(url); setLoading(false); }
    });
    return () => {
      cancelled = true;
      if (prevUrl.current) URL.revokeObjectURL(prevUrl.current);
    };
  }, [item.id]);

  useEffect(() => { prevUrl.current = blobUrl; }, [blobUrl]);

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-4xl w-full">
        <DialogHeader>
          <DialogTitle>Payslip — {item.emp_no} {item.full_name}</DialogTitle>
        </DialogHeader>
        <div className="h-[75vh] w-full rounded border overflow-hidden bg-muted flex items-center justify-center">
          {loading ? (
            <div className="flex flex-col items-center gap-2 text-muted-foreground">
              <RefreshCw className="h-6 w-6 animate-spin" />
              <span className="text-sm">Loading payslip…</span>
            </div>
          ) : (
            <iframe src={blobUrl} className="w-full h-full border-0" title="Payslip Preview" />
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => api.download(`/payslips/item/${item.id}`, `payslip-${item.emp_no}.pdf`)}>
            <FileDown className="h-4 w-4" />Download PDF
          </Button>
          <DialogClose asChild><Button variant="ghost">Close</Button></DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
